var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 194,
    viewBox: "0 0 207 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.882 32.7859H116.347V43.2938H97.1097V32.7859H82.575L106.718 1.44629L130.882 32.7859Z",
    fill: "#2F68E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5622 52.4128C49.569 52.7258 49.5133 53.037 49.3983 53.3282C49.2833 53.6193 49.1113 53.8846 48.8924 54.1085C48.6735 54.3323 48.4121 54.5102 48.1235 54.6317C47.835 54.7531 47.5251 54.8158 47.212 54.8159C46.8989 54.8161 46.589 54.7537 46.3003 54.6325C46.0117 54.5113 45.7501 54.3336 45.531 54.11C45.3119 53.8864 45.1397 53.6212 45.0244 53.3302C44.9091 53.0391 44.8531 52.7279 44.8596 52.4149C44.8725 51.8 45.1257 51.2146 45.5651 50.7842C46.0044 50.3538 46.5948 50.1126 47.2099 50.1123C47.8249 50.112 48.4156 50.3527 48.8553 50.7827C49.295 51.2127 49.5488 51.7979 49.5622 52.4128Z",
    fill: "#90B1FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1489 96.7959V104.054H74.1156V96.7959H70.1489Z",
    fill: "#90B1FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6895 96.7959V104.054H79.6551V96.7959H75.6895Z",
    fill: "#90B1FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2192 96.7959V104.054H85.1956V96.7959H81.2192Z",
    fill: "#90B1FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7488 96.7959V104.054H90.7359V96.7959H86.7499H86.7488Z",
    fill: "#90B1FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2866 96.7959V104.054H96.2737V96.7959H92.2866Z",
    fill: "#90B1FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8274 96.7959V104.054H101.813V96.7959H97.8274Z",
    fill: "#90B1FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.368 96.7959V104.054H107.354V96.7959H103.368Z",
    fill: "#90B1FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.908 96.7959V104.054H112.894V96.7959H108.908Z",
    fill: "#90B1FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.928 16.5371V28.1897",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.755 22.3711H151.102",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.387 125.805V49.6542C175.388 48.3966 175.016 47.1671 174.317 46.1211C173.619 45.0751 172.626 44.2597 171.465 43.7779C170.693 43.4587 169.865 43.2949 169.03 43.2959H44.4074C43.572 43.2946 42.7447 43.4582 41.9727 43.7773C41.2007 44.0964 40.4992 44.5647 39.9085 45.1554C39.3179 45.746 38.8496 46.4475 38.5305 47.2195C38.2114 47.9915 38.0478 48.8189 38.0491 49.6542V128.407",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.389 61.4902H38.071",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5612 52.4144C49.5681 52.7274 49.5123 53.0386 49.3973 53.3298C49.2823 53.621 49.1103 53.8863 48.8914 54.1101C48.6725 54.3339 48.4111 54.5118 48.1226 54.6333C47.834 54.7548 47.5241 54.8174 47.211 54.8176C46.898 54.8177 46.588 54.7553 46.2994 54.6341C46.0107 54.5129 45.7492 54.3353 45.5301 54.1116C45.311 53.888 45.1387 53.6229 45.0234 53.3318C44.9081 53.0407 44.8521 52.7295 44.8587 52.4165C44.8769 51.8054 45.1324 51.2253 45.571 50.7994C46.0097 50.3734 46.5969 50.135 47.2084 50.1348C47.8198 50.1345 48.4073 50.3723 48.8463 50.7979C49.2853 51.2234 49.5414 51.8032 49.5602 52.4144H49.5612Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6544 52.4142C56.6544 53.0377 56.4067 53.6356 55.9658 54.0764C55.525 54.5173 54.9271 54.765 54.3036 54.765C53.6802 54.765 53.0822 54.5173 52.6414 54.0764C52.2005 53.6356 51.9529 53.0377 51.9529 52.4142C51.9529 51.7908 52.2005 51.1928 52.6414 50.752C53.0822 50.3111 53.6802 50.0635 54.3036 50.0635C54.9271 50.0635 55.525 50.3111 55.9658 50.752C56.4067 51.1928 56.6544 51.7908 56.6544 52.4142Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7874 52.4131C63.7876 52.7218 63.7269 53.0276 63.6089 53.3128C63.4909 53.5981 63.3179 53.8573 63.0997 54.0757C62.8815 54.2941 62.6224 54.4673 62.3373 54.5856C62.0521 54.7039 61.7465 54.7648 61.4378 54.765C61.1291 54.7651 60.8233 54.7044 60.5381 54.5864C60.2528 54.4684 59.9936 54.2954 59.7752 54.0772C59.5568 53.859 59.3836 53.6 59.2653 53.3148C59.147 53.0296 59.0861 52.724 59.0859 52.4153C59.0857 51.7918 59.333 51.1938 59.7737 50.7528C60.2143 50.3117 60.8121 50.0638 61.4356 50.0635C62.0591 50.0632 62.6571 50.3106 63.0981 50.7512C63.5392 51.1919 63.7871 51.7897 63.7874 52.4131Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.92 106.405H67.8362V94.4463H151.92V106.405Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1453 96.7959V104.054H74.1119V96.7959H70.1453Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6858 96.7959V104.054H79.6514V96.7959H75.6858Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2156 96.7959V104.054H85.1919V96.7959H81.2156Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7451 96.7959V104.054H90.7312V96.7959H86.7451Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2859 96.7959V104.054H96.273V96.7959H92.2859Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8264 96.7959V104.054H101.812V96.7959H97.8264Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.367 96.7959V104.054H107.353V96.7959H103.367Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.908 96.7959V104.054H112.894V96.7959H108.908Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1095 43.2957V32.7878H82.5747L106.718 1.42773L130.882 32.7878H116.347V43.2957",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M196.179 77.0469V111.902",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M190.905 86.881L196.179 76.9863L201.454 86.881",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90601 90.7754H8.8571",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1855 90.7451H28.1366",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 77.6406V84.5917",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.03 96.9395V103.889",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72803 81.5059L10.6554 86.4118",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3845 95.1191L24.3109 100.025",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2711 81.4648L19.3652 86.3923",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.657 95.1406L5.75 100.047",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2593 172.885C40.3 174.695 39.0807 176.355 37.6401 177.811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6704 147.638C81.2483 144.367 84.5248 141.714 88.2602 139.873C91.9956 138.032 96.0954 137.049 100.26 136.996C104.424 136.943 108.547 137.822 112.328 139.568C116.109 141.313 119.452 143.882 122.112 147.086",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M167.657 136.13C168.022 134.111 168.815 132.194 169.982 130.506C171.15 128.819 172.665 127.401 174.426 126.348C176.188 125.296 178.154 124.632 180.193 124.402C182.232 124.172 184.297 124.382 186.248 125.016C188.199 125.651 189.991 126.697 191.505 128.083C193.018 129.468 194.217 131.161 195.022 133.049C195.827 134.936 196.218 136.973 196.17 139.025C196.123 141.076 195.636 143.093 194.745 144.941C197.183 146.247 199.33 148.037 201.052 150.202C202.775 152.366 204.037 154.86 204.762 157.53C205.486 160.2 205.658 162.989 205.267 165.728C204.876 168.466 203.929 171.096 202.486 173.456C201.042 175.816 199.132 177.856 196.872 179.452C194.613 181.048 192.051 182.165 189.344 182.736C186.637 183.307 183.842 183.319 181.13 182.771C178.419 182.224 175.847 181.128 173.574 179.552C169.819 183.163 164.819 185.192 159.609 185.219C154.399 185.246 149.378 183.268 145.587 179.695C144.162 180.955 142.491 181.904 140.679 182.481C138.868 183.059 136.955 183.252 135.065 183.05C133.174 182.847 131.346 182.253 129.698 181.305C128.05 180.357 126.617 179.076 125.492 177.543C123.285 181.882 119.984 185.569 115.915 188.24C111.846 190.911 107.149 192.473 102.291 192.77C97.4325 193.068 92.5805 192.092 88.2154 189.939C83.8502 187.785 80.1231 184.529 77.4032 180.492C75.4632 181.912 73.1833 182.796 70.7931 183.054C68.403 183.312 65.9869 182.936 63.7883 181.964C62.5292 183.543 60.9689 184.856 59.198 185.827C57.4271 186.799 55.4809 187.408 53.4724 187.62C51.464 187.833 49.4333 187.644 47.4984 187.065C45.5635 186.486 43.7629 185.529 42.2013 184.248C40.1139 182.536 38.5188 180.299 37.5794 177.768C33.9358 181.476 29.065 183.726 23.8803 184.099C18.6956 184.472 13.553 182.94 9.41675 179.792C6.67691 177.705 4.48239 174.986 3.02027 171.868C1.55815 168.749 0.871791 165.323 1.01971 161.882C1.24449 156.689 3.35612 151.756 6.9586 148.008C10.5611 144.261 15.4069 141.956 20.5874 141.527C19.8745 139.219 19.7135 136.777 20.1175 134.396C20.5215 132.014 21.479 129.762 22.9131 127.818C24.3471 125.875 26.2176 124.296 28.3737 123.208C30.5299 122.119 32.9114 121.553 35.3266 121.554C36.2453 121.553 37.162 121.634 38.0657 121.799",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.676 145.594C128.394 143.485 128.548 141.34 129.129 139.293C129.71 137.246 130.705 135.341 132.053 133.694C134.084 131.214 136.831 129.423 139.919 128.565C143.007 127.706 146.285 127.824 149.304 128.901C152.323 129.977 154.935 131.961 156.783 134.58C158.631 137.198 159.624 140.324 159.627 143.529",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M158.708 138.234C161.134 136.986 163.799 136.27 166.525 136.136C169.25 136.002 171.973 136.453 174.51 137.458",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3892 130.181C38.9541 127.401 44.3912 126.422 49.6392 127.434C54.8872 128.447 59.5695 131.379 62.7723 135.658C64.8936 138.493 66.2813 141.808 66.8122 145.308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8299 181.982C62.0583 181.194 60.4706 180.046 59.1682 178.609",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0419 176.586C80.103 178.118 78.874 179.451 77.4238 180.512",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M125.63 177.71C124.783 176.6 124.114 175.366 123.646 174.052",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.201 174.684C148.403 176.614 147.172 178.335 145.603 179.713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5029 138.03C66.0322 137.333 67.6934 136.974 69.3738 136.976C71.0543 136.977 72.7147 137.34 74.2426 138.04C75.7704 138.74 77.1299 139.76 78.2288 141.032C79.3276 142.303 80.1403 143.796 80.6117 145.409",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M119.679 144.509C120.892 143.421 122.318 142.598 123.866 142.091C125.415 141.584 127.052 141.405 128.674 141.566",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M140.553 153.057C141.723 153.292 142.821 153.796 143.763 154.528",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M142.739 155.978C143.929 153.985 145.709 152.412 147.834 151.477C149.96 150.543 152.323 150.295 154.596 150.766",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M172.954 160.087C173.359 158.354 174.386 156.83 175.842 155.805C177.298 154.781 179.079 154.328 180.847 154.532C182.616 154.737 184.247 155.585 185.43 156.915C186.613 158.245 187.266 159.963 187.263 161.743",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M166.332 158.066C166.948 157.103 167.87 156.376 168.95 156.003C170.031 155.63 171.205 155.632 172.284 156.01C172.999 156.261 173.649 156.669 174.186 157.205",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6377 149.232C33.6811 148.537 34.8679 148.085 36.1099 147.912C37.3518 147.738 38.617 147.846 39.8113 148.229C41.0056 148.611 42.0983 149.258 43.0082 150.121C43.9181 150.984 44.6218 152.041 45.067 153.213",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9968 150.133C43.7283 149.36 44.6615 148.806 45.691 148.536C46.7204 148.265 47.8052 148.287 48.8226 148.6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4988 168.124C86.5135 166.351 88.0779 164.957 89.9554 164.153C91.8329 163.349 93.9212 163.178 95.9044 163.666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5725 164.301C82.5535 164.221 83.5404 164.347 84.4699 164.671C85.3993 164.995 86.2509 165.509 86.9701 166.181",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8564 9.78778C56.8564 10.2559 56.9953 10.7135 57.2553 11.1027C57.5154 11.492 57.8851 11.7953 58.3176 11.9745C58.7501 12.1536 59.226 12.2005 59.6851 12.1092C60.1442 12.0179 60.5659 11.7924 60.897 11.4614C61.228 11.1304 61.4534 10.7087 61.5447 10.2495C61.6361 9.7904 61.5892 9.3145 61.41 8.88201C61.2309 8.44952 60.9275 8.07987 60.5383 7.81979C60.1491 7.55971 59.6915 7.4209 59.2233 7.4209C58.5961 7.4226 57.9951 7.67252 57.5516 8.11602C57.1081 8.55953 56.8581 9.16057 56.8564 9.78778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.1d68348a4d38da2ba024e707d7011d5d.svg";
export { ForwardRef as ReactComponent };